'use client';
import { useTranslations } from 'next-intl';
import styles from './Cost.module.scss';
import { FeedbackForm } from '../FeedbackForm';
import { useState } from 'react';
import { trackEvent } from '@/shared/components/GoogleMetrika/GoogleMetrika';

const isOnlyEng = process.env.NEXT_PUBLIC_IS_ONLY_EN === 'True';

export const Cost = () => {
  const t = useTranslations('ui.cost');
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);

  function handleOpenModal(){
    trackEvent('button_click', {
      button_name: 'contact_from_button',
      page: window.location.pathname,
    });
    setFeedbackOpen(true);
  }
  
  return isOnlyEng ? null : (
    <section className={styles.container}>
      <h2>{t('price')}</h2>

      <div className={styles.table}>
        <div className={styles.cell}>{t('license')}</div>

        <button
          className={styles.cell_btn}
          onClick={handleOpenModal}
        >
          {t('discuss')}
        </button>
      </div>
      <FeedbackForm
        isOpen={isFeedbackOpen}
        onClose={() => setFeedbackOpen(false)}
      />
    </section>
  );
};
